import { render, staticRenderFns } from "./WelcomeStory.vue?vue&type=template&id=1a87ec80&scoped=true&"
import script from "./WelcomeStory.vue?vue&type=script&lang=js&"
export * from "./WelcomeStory.vue?vue&type=script&lang=js&"
import style0 from "./WelcomeStory.vue?vue&type=style&index=0&id=1a87ec80&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a87ec80",
  null
  
)

export default component.exports